<div class="form" [formGroup]="form()">
  <div class="row">
    <fu-simple-input
      [useOutlineLabel]="false"
      formControlName="name"
      [label]="'withdrawal.cardPersonal.name.label' | translate"
      [placeholder]="'withdrawal.cardPersonal.name.placeholder' | translate"
    />
    <fu-simple-input
      [useOutlineLabel]="false"
      formControlName="surname"
      [label]="'withdrawal.cardPersonal.surname.label' | translate"
      [placeholder]="'withdrawal.cardPersonal.surname.placeholder' | translate"
    />
  </div>
  <fu-simple-input
    [useOutlineLabel]="false"
    formControlName="cardNumber"
    maskPattern="DDDD DDDD DDDD DDDD"
    [errorDictionary]="cardNumberErrors"
    [label]="'withdrawal.cardPersonal.cardNumber.label' | translate"
    [placeholder]="'withdrawal.cardPersonal.cardNumber.placeholder' | translate"
  />
  <fu-simple-input
    [useOutlineLabel]="false"
    formControlName="description"
    [label]="'withdrawal.cardPersonal.description.label' | translate"
    [placeholder]="
      'withdrawal.cardPersonal.description.placeholder' | translate
    "
  />
</div>
